var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var Heading4Icon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M5.268 9.736L3.056 9.4V8H10.672V9.4L8.264 9.736V17.268H18.12V9.736L15.852 9.4V8H23.356V9.4L21.144 9.736V27.152L23.356 27.432V28.804H15.824V27.432L18.12 27.152V19.004H8.264V27.152L10.7 27.432V28.804H3V27.432L5.268 27.152V9.736Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M29.0836 26.6744H24.8801L24.4725 26.0121C25.2028 24.6279 26.4086 21.9572 28.09 18H28.4722L29.9115 18.7388L26.6634 24.9294L26.1029 25.7573L29.0963 25.579L29.2237 23.197L30.6121 23.0824V25.4771L32.2426 25.3879V26.6744H30.6121V28.7125H29.0836V26.6744Z",
    fill: "black"
  }));
};
export var Heading4IconGlyph = function (props) {
  return React.createElement(Heading4Icon, __assign({}, props, {
    variant: 'glyph'
  }));
};